import { useContext } from "react";
import { Link, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

import { JoyrideContext } from "./JoyrideContext";
import { useNavigate } from "react-router-dom";

export function JoyrideActivateButton() {
  const navigate = useNavigate();
  const { activateJoyride } = useContext(JoyrideContext);

  const { t } = useTranslation();

  function startJoyride() {
    navigate("/");

    const layersetSelection = document.getElementById("layerset-content");
    if (layersetSelection) {
      layersetSelection.scrollTo({ top: 0 });
    }

    setTimeout(() => activateJoyride(true), 500);
  }
  return (
    <StyledLink color="primary" className="how-to-link" onClick={startJoyride}>
      {t("label.howDoIUseThisApplication")}
    </StyledLink>
  );
}

const StyledLink = styled(Link)`
  font-weight: 700;
  font-size: 14px;

  margin-right: ${({ theme }) => theme.spacing(2)};
`;
